import { ReactNode } from 'react';

import { Grid, Typography } from '@mui/material';
import { V2_SIDEBAR_WIDTH_COLLAPSED_PX, V2_SIDEBAR_WIDTH_PX } from 'src/v2/components/_constants';

import Link from '~components/shared/link';
import { black } from '~components/theme/styles/colors';

export const SidebarItem: React.FC<{
  icon: ReactNode;
  text: ReactNode;
  href: string;
  active: boolean;
  collapsed: boolean;
  width?: string;
  onClick?: () => void;
}> = ({ icon, text, collapsed, href, active, width, onClick }) => (
  <Link href={href} onClick={onClick}>
    <Grid
      container
      sx={{
        width: width ? width : collapsed ? V2_SIDEBAR_WIDTH_COLLAPSED_PX : V2_SIDEBAR_WIDTH_PX,
        padding: '16px 24px',
        paddingLeft: active && !collapsed ? '34px' : undefined,
        background: active ? black['85%'] : undefined,
        borderLeft: '0px',
        transition: 'border 0.15s linear, background 0.15s linear',
        ': hover': {
          background: active ? black['85%'] : black['15%'],
          borderLeft: 'solid 3px white',
        },
      }}
    >
      <Grid sx={{ display: 'flex', alignItems: 'center', gap: '24px' }}>
        {icon}
        {!collapsed ? <Typography variant="label3">{text}</Typography> : null}
      </Grid>
    </Grid>
  </Link>
);
